export function displayHandle(value='') {
 const name=String(value??'').trim().replace(/^(?:@\s*)+/,'').trim();
 return name?'@'+name:'';
}
